/* Landing wellfresh — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'wellfresh'). */


// galería
const main=document.getElementById('mainImg');
document.querySelectorAll('#thumbs button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('#thumbs button').forEach(x=>x.classList.remove('on'));
  b.classList.add('on'); main.src=b.querySelector('img').src; main.alt=b.querySelector('img').alt;
}));
// bundles → sticky
const sName=document.getElementById('sName'), sPrice=document.getElementById('sPrice');
document.querySelectorAll('.bundle').forEach(l=>l.addEventListener('click',()=>{
  document.querySelectorAll('.bundle').forEach(x=>x.classList.remove('on'));
  l.classList.add('on'); l.querySelector('input').checked=true;
  sName.textContent=l.dataset.name; sPrice.innerHTML=l.dataset.price+'<s>'+l.dataset.old+'</s>';
}));
// sticky visible después del buy box
const sticky=document.getElementById('sticky'), buyCta=document.querySelector('.buy .cta');
new IntersectionObserver(([e])=>sticky.classList.toggle('show',!e.isIntersecting && e.boundingClientRect.top<0)).observe(buyCta);
// imagen faltante → fondo menta (mientras se generan)
document.querySelectorAll('img').forEach(i=>i.addEventListener('error',()=>{i.style.visibility='hidden'}));

// pedido → WhatsApp (en Shopify se reemplaza por el formulario COD)
const WA_TIENDA='573007290464';
const modal=document.getElementById('modal');
const closeModal=()=>{modal.classList.remove('open');document.body.style.overflow='';};
modal.addEventListener('click',e=>{if(e.target===modal||e.target.closest('[data-close]'))closeModal();});
function openOrder(){
  const l=document.querySelector('.bundle.on');
  window.__wellfresh_SEL={qty:+l.dataset.qty||1,name:l.dataset.name,price:l.dataset.price};
  try{localStorage.setItem('te_regalo','wellfresh|'+Date.now())}catch(e){}
  if(window.wellfreshTriggerCOD&&window.wellfreshTriggerCOD()!==false)return;
  document.getElementById('msum').innerHTML=`<div><span>${l.dataset.name}</span><b>$${l.dataset.price}</b></div><div><span>Envío</span><span>Gratis</span></div><div><span>🎁 Regalos</span><span>3 guías por WhatsApp</span></div><div><span>Pago</span><span>Contra entrega</span></div>`;
  const msg=`Hola, quiero pedir el Kit Punto Ciego: ${l.dataset.name} por $${l.dataset.price}, pago contra entrega.`;
  document.getElementById('mWa').href=`https://api.whatsapp.com/send/?phone=${WA_TIENDA}&text=${encodeURIComponent(msg)}`;
  modal.classList.add('open');document.body.style.overflow='hidden';
}
document.querySelectorAll('[data-buy]').forEach(x=>x.addEventListener('click',openOrder));
// countdown real al 31-oct-2026 23:59 hora Colombia (UTC-5)
const END=new Date('2026-11-01T04:59:59Z').getTime();
function tick(){const d=END-Date.now(),el=document.getElementById('cd');if(!el)return;if(d<=0){el.textContent='terminó';return;}
  const days=Math.floor(d/864e5),h=Math.floor(d/36e5)%24,mi=Math.floor(d/6e4)%60,se=Math.floor(d/1e3)%60;
  el.textContent=`${days}d ${String(h).padStart(2,'0')}:${String(mi).padStart(2,'0')}:${String(se).padStart(2,'0')}`;}
tick();setInterval(tick,1000);

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN (memoria project-northpower-landing / project-diosa-landing):
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug NorthPower #1019).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function current() {
    var s = window.__wellfresh_SEL || {};
    var V = window.WELLFRESH_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    var q = s.qty;
    if (!q) { var on = document.querySelector('.bundle.on'); q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return v ? { id: v.id, qty: q || 1 } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__wellfresh-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.wellfreshTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
